<template>
  <v-row>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('edit')">
        <v-icon left>mdi-pencil</v-icon>
        {{$t('DeviceTypes.edit')}}
      </v-btn>
    </v-col>
    <v-col class="text-center">
      <v-btn class="ma-2" v-if="admin" tile outlined color="primary" @click="$emit('user')">
        <v-icon left>mdi-account</v-icon>{{$t('DeviceTypes.manage')}}
      </v-btn>
    </v-col>
    <v-col class="text-center">
      <delete-dialog @deletedeviceType="$emit('delete')" :admin="admin"></delete-dialog>
    </v-col>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>{{$t('DeviceTypes.back')}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

import DeleteDialogComponent from './DeleteDialog';

export default {
  components:{
    "delete-dialog": DeleteDialogComponent,
  },
  props: {
    admin: Boolean
  }
};
</script>


